//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions } from 'vuex'
import { MODAL } from "../../store/modulesNames"
import CustomSearch from "../custom/CustomSearch.vue"
import FilterTypeList from "./FilterTypeList.vue"
import modal_mixin from "./modal-mixin"
import { ACT_MODAL_CLOSE } from "../../store/actionsTypes"

import { CONTACT_FIELD_TYPES } from '../../constants'


export default {
    name: "FilterContactType",
    components: { CustomSearch, FilterTypeList },
    mixins: [modal_mixin],
    props: {
        filter: {
            type: Object,
            required: false,
            default: () => ({})
        },
        itemType: {
            type: String
        },
        calbackItem: {
            type: Function
        },
        calbackNewData: {
            type: Function
        }
    },
    data: () => {
        return {
            compModalProps: {
                delay: 350,
                pivotY: 0.05,
                width: 400,
                height: 'auto',
                clickToClose: false
            },
            selected: [],
            search: '',
            settingsFilter: {},
            filterClone: {
                [CONTACT_FIELD_TYPES.ORGANIZATION]: [],
                [CONTACT_FIELD_TYPES.OFFICE]: [],
                [CONTACT_FIELD_TYPES.POST]: []
            },
            newDataSettings: {
                [CONTACT_FIELD_TYPES.ORGANIZATION]: [],
                [CONTACT_FIELD_TYPES.OFFICE]: [],
                [CONTACT_FIELD_TYPES.POST]: []
            },
        }
    },
    created () {
        this.filterClone = JSON.parse(JSON.stringify(this.filter))
    },
    computed: {
        title () {
            if (this.itemType === CONTACT_FIELD_TYPES.ORGANIZATION) return this.$t('information.organizations')
            if (this.itemType  === CONTACT_FIELD_TYPES.OFFICE) return this.$t('information.departments')
            if (this.itemType  === CONTACT_FIELD_TYPES.POST) return this.$t('information.positions')
        },
        searchList () {
            return this.filterClone[this.itemType]
        }
    },
    methods: {
        onContactSelected(contact) {
            let type = this.itemType
            if (this.filterClone[type].includes(contact)) {
                this.filterClone[type].splice(this.filterClone[type].indexOf(contact), 1)
                this.newDataSettings[type].splice(this.newDataSettings[type].indexOf(contact), 1)
                return
            }
            this.filterClone[type].push(contact)
            this.newDataSettings[type].push(contact)
        },
        onOk() {
            this.calbackItem(this.filterClone)
            this.calbackNewData(this.newDataSettings)
            this[ACT_MODAL_CLOSE]({name: "FilterContactType"})
        },
        onCancel() {
            this[ACT_MODAL_CLOSE]({name: "FilterContactType"})
        },
        ...mapActions(MODAL, [ACT_MODAL_CLOSE])
    }
}

